<div class="box-video-recording">
    <div class="image-recording algin-center w-100">
        <h2 class="font-bold" style="color: #000000">
            Are you sure you want <br />
            to publish all feedbacks? <br />
            <br />
        </h2>
    </div>
    <button class="btn-yes-recording font-bold btn-common-style" (click)="onClickPublickFeedback()">Yes, I am.</button>
    <button class="btn-no-recording font-bold btn-common-style" (click)="onClose()">No, I am not.</button>
</div>
